module.exports = __webpack_public_path__ + "img/8.94e83560.png";